import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jiangbei",
  "use": "icon-jiangbei-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-jiangbei\"><path d=\"M819.2 102.4V0H204.8v102.4H0V256c0 128 96 236.8 224 249.6 38.4 108.8 128 185.6 236.8 204.8v211.2H307.2V1024h409.6V921.6H563.2V710.4C672 691.2 768 614.4 800 505.6 928 492.8 1024 384 1024 256V102.4H819.2zM102.4 256v-51.2h102.4v198.4c-64-25.6-102.4-83.2-102.4-147.2zm819.2 0c0 64-38.4 121.6-102.4 147.2V204.8h102.4V256z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol